import { Component,ViewChild, ElementRef, OnDestroy } from '@angular/core';
import {API_ENDPOINT_CREATE,API_DOMAIN_URL, uxControls} from '../../config/constants';
import { QRCodeComponent } from 'angularx-qrcode';
import { FormsModule, FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { ClipboardService } from 'ngx-clipboard';
import { StableLinkIntegrationService } from '../../core/services/stable-link-integration.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { Timestamp } from '../../../timestamp/Timestamp';
import { EmailValidationService, EmailValidationResult, UserSearchResult } from '../../core/services/email-validation.service';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-my-links',
    templateUrl: './my-links.component.html',
    styleUrls: ['./my-links.component.scss'],
    standalone: false
})
export class MyLinksComponent implements OnDestroy {
  @ViewChild("qrcode", {static: false}) qrcode: QRCodeComponent;
  @ViewChild("shareDialog", {static: false}) shareDialog: any;
  compiledTimestamp: string = Timestamp.stamp;
  
  isHovered = false;
  title = 'Hi Welcome to URL Shortener';
  //isSelected=false;
  //items: any[];
  pageSize: number = 10; //number for pagination in adminArea
  currentPage: number = 1;
  order: string = 'dateCreated'; // Default sort by created date
  reverse: boolean = true; // Default descending order (newest first)
  checkboxShortUrls: any[] = [];

  public user: string;
  public bulkBlue: boolean = false;
  public bulkBluePublished: boolean = false;
  public bulkBlueArchived: boolean = false;
  public bulkBlueDeleted: boolean = false;
  public originalUrl!: string;
  public shortUrl!: string;
  public itemId!: string;
  public retentionInYears!: number;
  public isShortenUrl: boolean = false;
  public isAdminArea: boolean = false;
  public shortenUrl: string = '';
  public isValidUrl: boolean = false;
  public isValidUrlEM: boolean = false;
  public totalDocs_val: number = 0;
  public isValid_val: string = '';
  public icon_warning: string = "\u2718";
  public icon_info: string = "\u2139";
  public icon_success: string = "\u2713";
  public selectedItemsCount: number = 0;
  public selectedItemsCountPublished: number = 0;
  public selectedItemsCountArchived: number = 0;
  public selectedItemsCountDeleted: number = 0;
  public preferred_Username!: string;
  username = '';
    
  public filteredRecords: any[] = [];
  public allRecords: any[] = [];
  filterStatus: 'All' | 'Published' | 'Archived' | 'Deleted'  = 'All';
  
  // Change owner modal state (supports bulk)
  showChangeOwnerModal: boolean = false;
  selectedItemsForOwnerChange: any[] = []; // Changed to array for bulk support
  newOwnerEmail: string = '';
  showTransferOwnershipInput: boolean = false; // Two-step process
  
  // Email validation for transfer ownership
  ownerEmailValidationResult: EmailValidationResult | null = null;
  isValidatingOwnerEmail: boolean = false;
  private ownerEmailValidationSubject$ = new Subject<string>();
  
  // Debouncing timer for transfer ownership (like share dialog)
  private ownerTypingTimer: any;
  private readonly OWNER_DEBOUNCE_TIME = 2000; // 2 seconds wait time
  
  // User search for transfer ownership
  isSearchingOwner: boolean = false;
  ownerSearchResults: UserSearchResult[] = [];
  showOwnerDropdown: boolean = false;
  
  // Simple popup notification
  public showNotification: boolean = false;
  public notificationMessage: string = '';
  public notificationType: 'success' | 'error' | 'info' = 'info';
  private notificationTimeout: any;
  

  get token() {
    return this.oauthService.getAccessToken();
  }
  get claims() {
    return this.oauthService.getIdentityClaims();
  }

  // Get the count of active links (excluding permanently deleted)
  get userLinkCount(): number {
    if (!this.allRecords || this.allRecords.length === 0) {
      return 0;
    }
    
    const now = new Date();
    return this.allRecords.filter(record => {
      // Include records that are:
      // 1. Not deleted at all (isDeleted is false/null/undefined)
      // 2. OR deleted but still in recycle bin (deletedAt is null or >= now)
      return !record.isDeleted || 
             (record.isDeleted && (!record.deletedAt || new Date(record.deletedAt) >= now));
    }).length;
  }

  // Get the number of days items stay in recycle bin before permanent deletion
  get recycleBinDays(): number {
    return uxControls.recycleBinDays;
  }

  updateSelectedCount() {
    // Only count non-deleted items in selection
    this.selectedItemsCount = this.filteredRecords.filter(item => item.selected && !item.isDeleted).length;
    console.log("selected: " + this.selectedItemsCount);
    this.selectedItemsCountPublished = this.filteredRecords.filter(item => item.selected && !item.isArchived && !item.isDeleted).length;
    console.log("selected Published: " + this.selectedItemsCountPublished);
    this.selectedItemsCountArchived = this.filteredRecords.filter(item => item.selected && item.isArchived && !item.isDeleted).length;
    console.log("selected Archived: " + this.selectedItemsCountArchived);
    this.selectedItemsCountDeleted = this.filteredRecords.filter(item => item.selected && item.isDeleted).length;
    console.log("selected Deleted: " + this.selectedItemsCountDeleted);
  }

  ngOnInit() {
    // Call login() when the component initializes
    this.getAdminArea();
    this.configService.login().subscribe(
      () => {
        console.log('Login successful');
        // Do any additional initialization tasks here
      },
      error => {
        // Handle login error
        console.error('Error during login:', error);
        this.oauthService.refreshToken();
        //sessionStorage.clear();
      }
    );
    this.oauthService.setupAutomaticSilentRefresh();
  }


  constructor(
    private configService: StableLinkIntegrationService,
    private oauthService: OAuthService,
    private clipboardService: ClipboardService,
    private emailValidationService: EmailValidationService
  ) {}

  pageChange(event){
    this.currentPage = event;
  }

  onChangeURL(url: SafeUrl, item :any) {
    item.qrCodeDownloadLink = url;
  }
  
  copyContent(url: string) {
    this.clipboardService.copyFromContent(url);
  }

  checkIsValidURL(item) {
    console.log("URL is being validated:", item.url);
    item.isValidUrl = false;
    item.isValidUrlEM = false;
    
    // Use the same URL validation regex as home page for consistency
    const urlRegex = '^https?://(?:.*?.)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    
    if (!item.url || item.url.trim() === '') {
      item.isValidUrlEM = true;
      item.isValid_val = 'URL is required';
      item.isValid_icon = this.icon_warning;
      return;
    }
    
    const trimmedUrl = item.url.trim();
    
    // Check for basic URL structure using same regex as home page
    const regix = new RegExp(urlRegex);
    if (!regix.test(trimmedUrl)) {
      item.isValidUrlEM = true;
      item.isValid_val = 'Please provide a valid URL.';
      item.isValid_icon = this.icon_warning;
      return;
    }
    
    // Check URL length (reasonable limits)
    if (trimmedUrl.length > 2048) {
      item.isValidUrlEM = true;
      item.isValid_val = 'URL is too long (maximum 2048 characters)';
      item.isValid_icon = this.icon_warning;
      return;
    }
    
    // If all checks pass
    item.isValidUrl = true;
    item.isValidUrlEM = false;
    item.isValid_val = 'Valid URL.';
    item.isValid_icon = this.icon_success;
  }

  btnShowSpan(){
    this.isHovered = true;
  }
  btnHideSpan(){
    this.isHovered = false;
  }

  getShortURL() {
    const data = [
      {
        creator: this.oauthService.getIdentityClaims()['preferred_username'], // this.creator,
        url: this.originalUrl,
        shortUrlId: this.shortUrl,
        retentionInYears: 1, // Hard coding this value to 1, please use retentionInYears in-case value needs to be collected from UI.
      },
    ];
    this.configService.post(API_ENDPOINT_CREATE, data, '').subscribe((resp) => {
      console.log(resp);

      if (resp !== null) {
        this.isShortenUrl = true;
        this.shortenUrl = API_DOMAIN_URL + resp['shortUrlIds'][0].shortUrlId;
        this.originalUrl = "";
        this.shortUrl = "";
      }
    });
  }
  updShortURL(item) {
    // Validate URL before saving
    this.checkIsValidURL(item);
    
    // Only proceed if URL is valid
    if (!item.isValidUrl || item.isValidUrlEM) {
      console.log('Cannot save: URL validation failed');
      return;
    }
    
    const data = [
      {
        _id: item._id, // Use MongoDB _id for precise targeting
        creator: this.oauthService.getIdentityClaims()['preferred_username'], // this.creator,
        url: item.url.trim(),
        isArchived: item.isArchived,
        shortUrlId: item.shortUrlId,
        retentionInYears: 1, // Hard coding this value to 1, please use retentionInYears in-case value needs to be collected from UI.
      },
    ];
    
    // Regular update endpoint (no need to check for deleted state since items marked for deletion are still in UI)
    this.configService.put(API_ENDPOINT_CREATE, data, '').subscribe((resp) => {
      console.log('URL update response:', resp);

      if (resp !== null) {
        this.isShortenUrl = true;
        this.shortenUrl = API_DOMAIN_URL + resp['shortUrlIds'][0].shortUrlId;
        this.originalUrl = "";
        this.shortUrl = "";
      }

      if (resp['error'] === "no") {
        const currentDate = new Date();
        item.modifiedAt = currentDate.toISOString();
        console.log('URL successfully updated');
      }
    }, (error) => {
      console.error('Error updating URL:', error);
      // Optionally show error message to user
    });
    
    this.toggleEdit(item);
  }

 onEscapePressed(): void {
  console.log('Escape key pressed!');
}
  
  getPageSize(pgSize: number) {
    // If pgSize is 0, set it to a very large number to show all items
    this.pageSize = pgSize === 0 ? 999999 : pgSize;
    this.currentPage = 1; // Reset to first page when changing page size
    this.getAdminArea();
  }


  getAdminArea() {
   //this.user="Imported@2024-05-22";
   this.user = this.oauthService.getIdentityClaims()['preferred_username'] ;
   // Get records with includeDeleted=true to also receive deleted records
   this.configService.get(API_ENDPOINT_CREATE + "/search/creator?creator=" + this.user + "&page=1&size=" + uxControls.maxLinksToFetch + "&includeDeleted=true", { responseType: 'text' }).subscribe((response: any) => {
      console.log(response);
      if (response['shortUrlId'] !== null) {
       
        //save all records as all dataset and filtered: 
       this.allRecords = response.records.map(record => ({
         ...record,
         totalRedirects: this.getTotalRedirects(record.redirectStats)
         // Note: API now includes deleted records with includeDeleted=true parameter
       }));

       // Re-apply current filter after data refresh
       this.refreshRecords(this.filterStatus);

       // this is a property that comes from api response:
       this.totalDocs_val = response.totalDocuments;
       //   this.filteredRecords = this.filteredRecords.map(item => ({
        //    selected: false // Initialize all items as not selected
        //  }));
       this.isAdminArea = true;
      }
    });
  }
  
  toggleEdit(item) {
    // Store backup URL for cancel functionality
    item.backupurl = item.url;
    
    // If editing is completed, trim the URL first to remove any spaces at the end
    if (item.isEditing) {
      item.url = item.url.trim();
      // Validate URL when finishing edit
      this.checkIsValidURL(item);
    } else {
      // Clear validation state when starting to edit
      item.isValidUrl = false;
      item.isValidUrlEM = false;
      item.isValid_val = '';
      item.isValid_icon = '';
      
      // Perform initial validation if URL exists
      if (item.url && item.url.trim()) {
        this.checkIsValidURL(item);
      }
    }
    
    item.isEditing = !item.isEditing;
  }

  handleCheckboxChange(pArchived:Boolean) {
    const selectedItems = this.filteredRecords.filter(item => item.selected);
    
    if (selectedItems.length === 0) {
      return;
    }
    
    // Filter items that need to be updated (only those that have different archive status)
    const itemsToUpdate = selectedItems.filter(item => 
      (item.isArchived !== undefined ? item.isArchived : false) === pArchived
    );
    
    if (itemsToUpdate.length === 0) {
      // Clear selections and refresh
      selectedItems.forEach(item => item.selected = false);
      this.updateSelectedCount();
      this.bulkBlue = false;
      this.bulkBluePublished = false;
      this.bulkBlueArchived = false;
      this.bulkBlueDeleted = false;
      return;
    }
    
    // Prepare bulk update with _id for precise targeting
    const updates = itemsToUpdate.map(item => ({
      _id: item._id, // Use MongoDB _id for precise targeting
      isArchived: !pArchived, // Toggle the archive status
      lastModifiedBy: this.oauthService.getIdentityClaims()['preferred_username']
    }));
    
    // Use PUT endpoint for bulk update
    this.configService.put(API_ENDPOINT_CREATE, updates).subscribe(
      (resp) => {
        console.log('Bulk archive/publish response:', resp);
        
        if (resp && (resp['error'] === 'no' || resp['error'] === undefined || resp['success'] === true)) {
          // Update UI state
          itemsToUpdate.forEach(item => {
            item.isArchived = !pArchived;
            item.modifiedAt = new Date().toISOString();
            item.lastModifiedBy = this.oauthService.getIdentityClaims()['preferred_username'];
            // Clear selection
            item.selected = false;
          });
          
          // Clear remaining selections
          selectedItems.forEach(item => item.selected = false);
          
          // Show success notification
          const action = pArchived ? 'archived' : 'published';
          this.showSimpleNotification(`${itemsToUpdate.length} item(s) ${action} successfully`, 'success', uxControls.notificationDuration);
        } else {
          console.warn('Server returned error for bulk archive/publish:', resp);
          this.showSimpleNotification('Failed to update selected items', 'error', uxControls.notificationDuration);
        }
      },
      (error) => {
        console.error('Error with bulk archive/publish:', error);
        this.showSimpleNotification('Network error while updating items', 'error', uxControls.notificationDuration);
      }
    );
    
    // Clear selection counts and refresh
    this.updateSelectedCount();
    this.bulkBlue = false;
    this.bulkBluePublished = false;
    this.bulkBlueArchived = false;
    this.bulkBlueDeleted = false;
    this.refreshRecords(this.filterStatus);
  }

  toggleSelect(item) {
    // Don't allow selection of deleted items unless we're in the Deleted view
    if (item.isDeleted && this.filterStatus !== 'Deleted') {
      return;
    }
    
    item.selected = !item.selected;
    this.updateSelectedCount();
    //enable button blue if selected more than 0 records
    this.bulkBlue = (this.selectedItemsCount > 0);
    // Publish button should be enabled when archived items are selected (to publish them)
    this.bulkBlueArchived = (this.selectedItemsCountArchived > 0);
    // Archive button should be enabled when published items are selected (to archive them)
    this.bulkBluePublished = (this.selectedItemsCountPublished > 0);
    // Delete button should be enabled when deleted items are selected (to permanently delete them)
    this.bulkBlueDeleted = (this.selectedItemsCountDeleted > 0);
  }

  // Select All functionality
  toggleSelectAll(): void {
    const allSelected = this.isAllSelected();
    
    // Get the current page items (in Deleted view, include deleted items; in other views, exclude them)
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    const currentPageItems = this.filteredRecords.slice(startIndex, endIndex).filter(item => 
      this.filterStatus === 'Deleted' ? item.isDeleted : !item.isDeleted
    );
    
    currentPageItems.forEach(item => {
      if (allSelected) {
        // Deselect all items on current page
        item.selected = false;
      } else {
        // Select all items on current page
        item.selected = true;
      }
    });
    
    this.updateSelectedCount();
    // Update bulk button states
    this.bulkBlue = (this.selectedItemsCount > 0);
    // Publish button should be enabled when archived items are selected (to publish them)
    this.bulkBlueArchived = (this.selectedItemsCountArchived > 0);
    // Archive button should be enabled when published items are selected (to archive them)
    this.bulkBluePublished = (this.selectedItemsCountPublished > 0);
    // Delete button should be enabled when deleted items are selected (to permanently delete them)
    this.bulkBlueDeleted = (this.selectedItemsCountDeleted > 0);
  }

  isAllSelected(): boolean {
    if (!this.filteredRecords || this.filteredRecords.length === 0) {
      return false;
    }
    
    // Get the current page items (in Deleted view, include deleted items; in other views, exclude them)
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    const currentPageItems = this.filteredRecords.slice(startIndex, endIndex).filter(item => 
      this.filterStatus === 'Deleted' ? item.isDeleted : !item.isDeleted
    );
    
    if (currentPageItems.length === 0) {
      return false;
    }
    
    // Check if all non-deleted items on current page are selected
    return currentPageItems.every(item => item.selected === true);
  }

  isIndeterminate(): boolean {
    if (!this.filteredRecords || this.filteredRecords.length === 0) {
      return false;
    }
    
    // Get the current page items (in Deleted view, include deleted items; in other views, exclude them)
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    const currentPageItems = this.filteredRecords.slice(startIndex, endIndex).filter(item => 
      this.filterStatus === 'Deleted' ? item.isDeleted : !item.isDeleted
    );
    
    if (currentPageItems.length === 0) {
      return false;
    }
    
    const selectedCount = currentPageItems.filter(item => item.selected === true).length;
    
    // Indeterminate if some but not all non-deleted items are selected
    return selectedCount > 0 && selectedCount < currentPageItems.length;
  }
  
  refreshRecords(status: 'All'|'Published'|'Archived'|'Deleted'):void {
    
    const now = new Date();
    
    switch (status) {
      case 'All':
        // Show only active records: not deleted
        this.filteredRecords = this.allRecords.filter(record => 
          !record.isDeleted
        );
        break;
      case 'Published':
        // Show only published records that are not deleted
        this.filteredRecords = this.allRecords.filter(record => 
          !record.isArchived && !record.isDeleted
        );
        break;
      case 'Archived':
        // Show only archived records that are not deleted
        this.filteredRecords = this.allRecords.filter(record => 
          record.isArchived && !record.isDeleted
        );
        break;
      case 'Deleted':
        // Show recently deleted records: isDeleted=true and (deletedAt is null or >= now)
        this.filteredRecords = this.allRecords.filter(record => 
          record.isDeleted && 
          (!record.deletedAt || new Date(record.deletedAt) >= now)
        );
        break;
      default:
        // Default to showing only active records
        this.filteredRecords = this.allRecords.filter(record => 
          !record.isDeleted
        );
        break;
    }
    this.filterStatus = status;
    
    // Update selection counts after filter change
    this.updateSelectedCount();
    this.bulkBlue = (this.selectedItemsCount > 0);
    this.bulkBlueArchived = (this.selectedItemsCountArchived > 0);
    this.bulkBluePublished = (this.selectedItemsCountPublished > 0);
    this.bulkBlueDeleted = (this.selectedItemsCountDeleted > 0);
    
    console.log("records for " + status + " were successfully refreshed");
  }


  showStatus(item: any):boolean {
    // API excludes deleted records by default, so all items in the list should be shown
    return true;
  }
  arcShortURL(item){
    this.configService.put(API_ENDPOINT_CREATE + "/isarchived/" + item._id, '').subscribe((resp) => {
      console.log(resp);

      if (resp['error'] === "no" ) {
        this.shortenUrl = API_DOMAIN_URL + resp['isArchived'][0];
        const currentDate = new Date();
        item.modifiedAt = currentDate.toISOString();
        item.isArchived = resp['isArchived'];
      }

    });
  }

  openShareDialog(item: any) {
    if (!item.isDeleted && this.shareDialog) {
      // Always pass as array (single item = array of 1)
      this.shareDialog.show([item]);
    }
  }

  handleShareApplied(event: {items: any[], selectedPeople: any[], removedPeople?: string[]}) {
    const { items, selectedPeople, removedPeople } = event;
    
    // Simplified: No radio buttons, just manage selectedPeople array
    items.forEach(item => {
      let existingPeople = item.selectedPeople || [];
      
      // First, remove any people that were deleted
      if (removedPeople && removedPeople.length > 0) {
        const removedSet = new Set(removedPeople);
        existingPeople = existingPeople.filter((p: any) => !removedSet.has(p.email));
      }
      
      // Then, add new people who don't already exist
      const existingEmails = new Set(existingPeople.map((p: any) => p.email));
      selectedPeople.forEach(newPerson => {
        if (!existingEmails.has(newPerson.email)) {
          existingPeople.push({ email: newPerson.email });
        }
      });
      
      item.selectedPeople = existingPeople;
    });
    
    // Persist sharing settings to backend
    console.log('Saving sharing settings to backend for ' + items.length + ' link(s)');
    
    // Prepare update payload for backend (using UpdateShortLinkInput format)
    // Note: multiOwnership can be set to null - backend will ignore it, icon driven by selectedPeople array
    const updates = items.map(item => ({
      _id: item._id,
      multiOwnership: null, // Not used anymore, icon driven by selectedPeople array
      selectedPeople: item.selectedPeople || []
    }));
    
    // Call backend PUT endpoint to persist sharing settings
    this.configService.put(API_ENDPOINT_CREATE, updates, '').subscribe(
      (resp) => {
        console.log('✅ Sharing settings saved successfully:', resp);
        
        // Show notification
        const linkText = items.length === 1 ? 'Link' : `${items.length} links`;
        let message: string;
        
        // Simplified notification message
        if (selectedPeople.length > 0 || (removedPeople && removedPeople.length > 0)) {
          message = `${linkText} sharing updated`;
        } else {
          message = `${linkText} updated`;
        }
        
        this.showSimpleNotification(message, 'success', uxControls.notificationDuration);
        
        // Deselect all items after bulk operation
        if (items.length > 1) {
          items.forEach(item => item.selected = false);
          this.updateSelectedCount();
        }
        
        // Refresh data to get latest from backend
        this.getAdminArea();
      },
      (error) => {
        console.error('❌ Failed to save sharing settings:', error);
        this.showSimpleNotification('Failed to update sharing settings. Please try again.', 'error', uxControls.notificationDuration);
        
        // Revert local changes on error by refreshing from backend
        this.getAdminArea();
      }
    );
  }
  
  openBulkShareDialog() {
    // Get all selected non-deleted items
    const selectedItems = this.filteredRecords.filter(item => item.selected && !item.isDeleted);
    
    if (selectedItems.length > 0 && this.shareDialog) {
      this.shareDialog.show(selectedItems);
    }
  }

  toggleDeleteShortURL(item: any) {
    if (item.isDeleted) {
      this.undoDelete(item);
    } else {
      this.markForDeletion(item);
    }
  }

  /**
   * Mark item for deletion (use DELETE endpoint with deletedAt parameter)
   */
  markForDeletion(item: any) {
    // Clear any previous error states
    item.deleteError = false;
    
    // Calculate deletedAt timestamp (now + recycle bin days)
    const deletedAt = new Date();
    deletedAt.setDate(deletedAt.getDate() + uxControls.recycleBinDays);
    
    // Use DELETE endpoint with deletedAt query parameter
    const deleteUrl = `${API_ENDPOINT_CREATE}/${item._id}?deletedAt=${encodeURIComponent(deletedAt.toISOString())}`;
    
    this.configService.delete(deleteUrl).subscribe(
      (resp) => {
        console.log('Soft delete response:', resp);
        
        // Update UI state - mark as deleted with deletedAt timestamp
        item.isDeleted = true;
        item.deletedAt = deletedAt.toISOString();
        item.deletedBy = this.oauthService.getIdentityClaims()['preferred_username'];
        const currentDate = new Date();
        item.modifiedAt = currentDate.toISOString();
        
        // Clear selection if item was selected
        if (item.selected) {
          item.selected = false;
          this.updateSelectedCount();
          this.bulkBlue = (this.selectedItemsCount > 0);
          this.bulkBlueArchived = (this.selectedItemsCountArchived > 0);
          this.bulkBluePublished = (this.selectedItemsCountPublished > 0);
          this.bulkBlueDeleted = (this.selectedItemsCountDeleted > 0);
        }
        
        // Show success notification
        this.showSimpleNotification('Link moved to recycle bin', 'success', uxControls.notificationDuration);
        
        // Refresh the current view after configured delay to remove the deleted item
        setTimeout(() => {
          this.refreshRecords(this.filterStatus);
        }, uxControls.uiRefreshDelay);
        
        console.log(`Item successfully moved to recycle bin - will be permanently deleted on ${deletedAt.toDateString()}`);
      },
      (error) => {
        console.error('Error deleting item on server:', error);
        // Handle different error types
        if (error.status === 404) {
          this.handleDeleteFailure(item, 'Link not found');
        } else if (error.status === 400) {
          this.handleDeleteFailure(item, 'Invalid deletion date');
        } else {
          this.handleDeleteFailure(item, 'Network or server error');
        }
      }
    );
  }

  /**
   * Undo the deletion by calling API to restore the item
   */
  undoDelete(item: any) {
    // Restore via API (set isDeleted=false, deletedAt=null) with includeDeleted=true
    const updateUrl = `${API_ENDPOINT_CREATE}?includeDeleted=true`;
    const updatePayload = [{
      _id: item._id, // Use MongoDB _id for precise targeting
      isDeleted: false,
      deletedAt: null,
      deletedBy: null,
      lastModifiedBy: this.oauthService.getIdentityClaims()['preferred_username']
    }];
    
    this.configService.put(updateUrl, updatePayload).subscribe(
      (resp) => {
        console.log('Restore response:', resp);
        
        if (resp && (resp['error'] === 'no' || resp['error'] === undefined || resp['success'] === true)) {
          item.isDeleted = false;
          item.deletedAt = null;
          item.deletedBy = null;
          item.deleteError = false;
          item.modifiedAt = new Date().toISOString();
          this.showSimpleNotification('Link restored from recycle bin', 'success', uxControls.notificationDuration);
          
          // Refresh the current view after configured delay to update the item's visibility
          setTimeout(() => {
            this.refreshRecords(this.filterStatus);
          }, uxControls.uiRefreshDelay);
          
          console.log(`Item ${item.shortUrlId} successfully restored from recycle bin`);
        } else {
          this.handleDeleteFailure(item, 'Server returned error response');
        }
      },
      (error) => {
        console.error('Error restoring item:', error);
        this.handleDeleteFailure(item, 'Network or server error');
      }
    );
  }

  /**
   * Handle restoration failure by showing error
   */
  private handleRestoreFailure(item: any, reason: string) {
    // Set error flag for visual indication
    item.deleteError = true;
    
    // Show error notification
    this.showSimpleNotification('Failed to restore link', 'error', uxControls.notificationDuration);
    
    // Clear error flag after configured delay
    setTimeout(() => {
      item.deleteError = false;
    }, uxControls.errorClearDelay);
    
    console.error(`Failed to restore item ${item.shortUrlId}: ${reason}`);
  }

  /**
   * Handle deletion failure by restoring item state and showing error
   */
  private handleDeleteFailure(item: any, reason: string) {
    // Set error flag for visual indication
    item.deleteError = true;
    
    // Show error notification
    this.showSimpleNotification('Failed to delete link', 'error', uxControls.notificationDuration);
    
    // Clear error flag after configured delay
    setTimeout(() => {
      item.deleteError = false;
    }, uxControls.errorClearDelay);
    
    console.error(`Failed to delete item ${item.shortUrlId}: ${reason}`);
  }

  // Helper method to update totalRedirects property for sorting
  updateTotalRedirects(item: any) {
    item.totalRedirects = this.getTotalRedirects(item.redirectStats);
  }

  columns: any[] = [
    { columnName: 'Short URL', value: 'shortUrl', active: false, reverse: false, sortable: true },
    { columnName: 'URL', value: 'url', active: false, reverse: false, sortable: true },
    { columnName: 'Actions', active: false, reverse: false, sortable: false },
    { columnName: 'Status',  value: 'isArchived', active: false, reverse: false, sortable: true },
    { columnName: 'Owner',  value: 'creator', active: false, reverse: false, sortable: true },
    { columnName: 'Created',  value: 'dateCreated', active: true, reverse: true, sortable: true }, // Default sort: newest first
    { columnName: 'Changed',  value: 'modifiedAt', active: false, reverse: false, sortable: true },
    { columnName: 'Redirects', value: 'totalRedirects', active: false, reverse: false, sortable: true }
  ];

  setOrder(column) {
    if (column.sortable) {
      this.columns.forEach((currentcolumn) => {
        if (currentcolumn !== column) {
          currentcolumn.active = false;
          currentcolumn.reverse = false;
        } else { 
          currentcolumn.active = true;this.order=column.value; currentcolumn.reverse = !currentcolumn.reverse; this.reverse = currentcolumn.reverse
        }
      });
    }
  }

  getTotalRedirects(stats: any): number {
    if (!stats) return 0;
    return Object.values(stats).reduce<number>((sum: number, count: any) => sum + Number(count), 0);
  }

  formatNumber(num: number): string {
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  }

  getRedirectsTooltip(stats: any): string {
    if (!stats || Object.keys(stats).length === 0) return 'No redirects';
    
    return Object.entries(stats)
      .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
      .map(([year, count]) => `${year}: ${count} redirects`)
      .join('\n');
  }

  /**
   * Check if a link is shared with others (not just creator)
   * Icon logic: empty array OR only creator = single user icon, otherwise = multi-user icon
   */
  isLinkShared(item: any): boolean {
    if (!item.selectedPeople || item.selectedPeople.length === 0) {
      return false; // Empty array = not shared
    }
    
    // If only one person and it's the creator = not shared
    if (item.selectedPeople.length === 1 && item.selectedPeople[0].email === item.creator) {
      return false;
    }
    
    // Otherwise = shared with others
    return true;
  }

  /**
   * Show simple notification popup
   */
  private showSimpleNotification(message: string, type: 'success' | 'error' | 'info' = 'info', duration: number = uxControls.notificationDuration): void {
    this.notificationMessage = message;
    this.notificationType = type;
    this.showNotification = true;
    
    // Clear any existing timeout
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
    
    // Auto-hide after duration
    this.notificationTimeout = setTimeout(() => {
      this.hideNotification();
    }, duration);
  }

  /**
   * Hide the notification
   */
  hideNotification(): void {
    this.showNotification = false;
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
      this.notificationTimeout = null;
    }
  }

  /**
   * Permanently delete selected items in recycle bin by setting deletedAt to now
   */
  permanentlyDeleteSelected() {
    const selectedDeletedItems = this.filteredRecords.filter(item => item.selected && item.isDeleted);
    
    if (selectedDeletedItems.length === 0) {
      this.showSimpleNotification('No deleted items selected', 'error', uxControls.notificationDuration);
      return;
    }

    // Confirm deletion
    const confirmMessage = `Are you sure you want to permanently delete ${selectedDeletedItems.length} item(s)? This action cannot be undone.`;
    if (!confirm(confirmMessage)) {
      return;
    }

    const updates = selectedDeletedItems.map(item => ({
      _id: item._id, // Use MongoDB _id for precise targeting
      isDeleted: true,
      deletedAt: new Date().toISOString(), // Set to now for permanent deletion
      deletedBy: item.deletedBy || this.oauthService.getIdentityClaims()['preferred_username'],
      lastModifiedBy: this.oauthService.getIdentityClaims()['preferred_username']
    }));

    // Use PUT endpoint with includeDeleted=true to update deleted records
    this.configService.put(`${API_ENDPOINT_CREATE}?includeDeleted=true`, updates).subscribe(
      (resp) => {
        console.log('Permanent delete response:', resp);
        
        if (resp && (resp['error'] === 'no' || resp['error'] === undefined || resp['success'] === true)) {
          // Update UI state - items should disappear from recycle bin
          selectedDeletedItems.forEach(item => {
            item.deletedAt = new Date().toISOString();
            item.lastModifiedBy = this.oauthService.getIdentityClaims()['preferred_username'];
            item.modifiedAt = new Date().toISOString();
            // Clear selection
            item.selected = false;
          });

          // Update selection counts
          this.updateSelectedCount();
          this.bulkBlueDeleted = false;

          // Show success notification
          this.showSimpleNotification(`${selectedDeletedItems.length} item(s) permanently deleted`, 'success', uxControls.notificationDuration);
          
          // Refresh the view to remove the permanently deleted items
          setTimeout(() => {
            this.refreshRecords(this.filterStatus);
          }, uxControls.uiRefreshDelay);
        } else {
          console.warn('Server returned error for permanent deletion:', resp);
          this.showSimpleNotification('Failed to permanently delete items', 'error', uxControls.notificationDuration);
        }
      },
      (error) => {
        console.error('Error permanently deleting items:', error);
        this.showSimpleNotification('Network error while deleting items', 'error', uxControls.notificationDuration);
      }
    );
  }

  /**
   * Empty the entire recycle bin by permanently deleting all deleted items
   */
  emptyRecycleBin() {
    // Get all deleted items currently in recycle bin (visible in current filter)
    const deletedItems = this.filteredRecords.filter(item => item.isDeleted);
    
    if (deletedItems.length === 0) {
      this.showSimpleNotification('Recycle bin is already empty', 'info', uxControls.notificationDuration);
      return;
    }

    // Confirm deletion
    const confirmMessage = `Are you sure you want to permanently delete all ${deletedItems.length} item(s) from the recycle bin? This action cannot be undone.`;
    if (!confirm(confirmMessage)) {
      return;
    }

    const updates = deletedItems.map(item => ({
      _id: item._id, // Use MongoDB _id for precise targeting
      isDeleted: true,
      deletedAt: new Date().toISOString(), // Set to now for permanent deletion
      deletedBy: item.deletedBy || this.oauthService.getIdentityClaims()['preferred_username'],
      lastModifiedBy: this.oauthService.getIdentityClaims()['preferred_username']
    }));

    // Use PUT endpoint with includeDeleted=true to update deleted records
    this.configService.put(`${API_ENDPOINT_CREATE}?includeDeleted=true`, updates).subscribe(
      (resp) => {
        console.log('Empty recycle bin response:', resp);
        
        if (resp && (resp['error'] === 'no' || resp['error'] === undefined || resp['success'] === true)) {
          // Update UI state - clear selections and update timestamps
          deletedItems.forEach(item => {
            item.deletedAt = new Date().toISOString();
            item.lastModifiedBy = this.oauthService.getIdentityClaims()['preferred_username'];
            item.modifiedAt = new Date().toISOString();
            // Clear selection
            item.selected = false;
          });

          // Update selection counts
          this.updateSelectedCount();
          this.bulkBlueDeleted = false;

          // Show success notification
          this.showSimpleNotification(`Recycle bin emptied - ${deletedItems.length} item(s) permanently deleted`, 'success', uxControls.notificationDuration);
          
          // Refresh the view to remove all permanently deleted items
          setTimeout(() => {
            this.refreshRecords(this.filterStatus);
          }, uxControls.uiRefreshDelay);
        } else {
          console.warn('Server returned error for emptying recycle bin:', resp);
          this.showSimpleNotification('Failed to empty recycle bin', 'error', uxControls.notificationDuration);
        }
      },
      (error) => {
        console.error('Error emptying recycle bin:', error);
        this.showSimpleNotification('Network error while emptying recycle bin', 'error', uxControls.notificationDuration);
      }
    );
  }

  /**
   * Cleanup timeouts when component is destroyed
   */
  ngOnDestroy(): void {
    // Clear notification timeout
    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
  }

  // Get initials from creator email (first 2 letters)
  getOwnerInitials(creator: string): string {
    if (!creator) return '??';
    const email = creator.toLowerCase();
    return email.substring(0, 2).toUpperCase();
  }

  // Generate consistent color for owner based on email
  getOwnerColor(creator: string): string {
    if (!creator) return 'bg-bosch-gray-400';
    
    // Hash the email to get a consistent number
    let hash = 0;
    for (let i = 0; i < creator.length; i++) {
      hash = creator.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Array of pleasant, distinguishable Bosch-compatible colors
    const colors = [
      'bg-bosch-blue-500',      // Blue
      'bg-purple-500',           // Purple
      'bg-green-500',            // Green
      'bg-orange-500',           // Orange
      'bg-pink-500',             // Pink
      'bg-teal-500',             // Teal
      'bg-indigo-500',           // Indigo
      'bg-red-500',              // Red
      'bg-cyan-500',             // Cyan
      'bg-amber-500',            // Amber
      'bg-emerald-500',          // Emerald
      'bg-violet-500',           // Violet
      'bg-fuchsia-500',          // Fuchsia
      'bg-lime-500',             // Lime
      'bg-rose-500',             // Rose
      'bg-sky-500'               // Sky
    ];
    
    // Use hash to pick a color (same email always gets same color)
    const colorIndex = Math.abs(hash) % colors.length;
    return colors[colorIndex];
  }

  // Get hover color variant for owner avatar
  getOwnerHoverColor(creator: string): string {
    if (!creator) return 'hover:bg-bosch-gray-500';
    
    const baseColor = this.getOwnerColor(creator);
    // Map base colors to their hover variants (darker shade)
    const hoverMap: {[key: string]: string} = {
      'bg-bosch-blue-500': 'hover:bg-bosch-blue-600',
      'bg-purple-500': 'hover:bg-purple-600',
      'bg-green-500': 'hover:bg-green-600',
      'bg-orange-500': 'hover:bg-orange-600',
      'bg-pink-500': 'hover:bg-pink-600',
      'bg-teal-500': 'hover:bg-teal-600',
      'bg-indigo-500': 'hover:bg-indigo-600',
      'bg-red-500': 'hover:bg-red-600',
      'bg-cyan-500': 'hover:bg-cyan-600',
      'bg-amber-500': 'hover:bg-amber-600',
      'bg-emerald-500': 'hover:bg-emerald-600',
      'bg-violet-500': 'hover:bg-violet-600',
      'bg-fuchsia-500': 'hover:bg-fuchsia-600',
      'bg-lime-500': 'hover:bg-lime-600',
      'bg-rose-500': 'hover:bg-rose-600',
      'bg-sky-500': 'hover:bg-sky-600'
    };
    
    return hoverMap[baseColor] || 'hover:bg-bosch-blue-600';
  }

  // Open change owner modal
  openChangeOwnerModal(items: any[]) {
    // Filter out deleted items
    const validItems = items.filter(item => !item.isDeleted);
    if (validItems.length === 0) return;
    
    this.selectedItemsForOwnerChange = validItems;
    this.newOwnerEmail = '';
    this.showTransferOwnershipInput = false; // Start with step 1
    this.showChangeOwnerModal = true;
  }
  
  // Open bulk change owner modal
  openBulkChangeOwnerModal() {
    const selectedItems = this.filteredRecords.filter(item => item.selected && !item.isDeleted);
    if (selectedItems.length > 0) {
      this.openChangeOwnerModal(selectedItems);
    }
  }

  // Close change owner modal
  closeChangeOwnerModal() {
    clearTimeout(this.ownerTypingTimer);
    this.showChangeOwnerModal = false;
    this.selectedItemsForOwnerChange = [];
    this.newOwnerEmail = '';
    this.showTransferOwnershipInput = false;
    this.ownerEmailValidationResult = null;
    this.isValidatingOwnerEmail = false;
    this.isSearchingOwner = false;
    this.ownerSearchResults = [];
    this.showOwnerDropdown = false;
  }
  
  // Triggered when user types in owner email/name input (with debouncing and smart detection)
  onOwnerEmailInput(input: string) {
    const trimmedInput = input.trim();
    
    // Clear previous timer
    clearTimeout(this.ownerTypingTimer);
    
    // Reset states
    this.ownerEmailValidationResult = null;
    this.ownerSearchResults = [];
    this.showOwnerDropdown = false;
    
    // Don't process empty input
    if (!trimmedInput) {
      this.isValidatingOwnerEmail = false;
      this.isSearchingOwner = false;
      return;
    }
    
    // If validation is disabled, skip all validation logic
    if (environment.allow_non_validated_emails === true) {
      return;
    }
    
    // Show loading indicator immediately
    if (this.looksLikeEmail(trimmedInput)) {
      this.isValidatingOwnerEmail = true;
      this.isSearchingOwner = false;
    } else {
      this.isValidatingOwnerEmail = false;
      this.isSearchingOwner = true;
    }
    
    // Start timer - wait 2 seconds before making API call
    this.ownerTypingTimer = setTimeout(() => {
      this.processOwnerInput(trimmedInput);
    }, this.OWNER_DEBOUNCE_TIME);
  }
  
  // Check if input looks like an email address (reused logic)
  private looksLikeEmail(input: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);
  }
  
  // Process input after debounce - validate email or search users (reused logic)
  private processOwnerInput(input: string) {
    if (this.looksLikeEmail(input)) {
      // Input is email - validate it
      console.log('📧 Owner input looks like email, validating...');
      this.isValidatingOwnerEmail = true;
      this.isSearchingOwner = false;
      
      this.emailValidationService.validateCorporateEmail(input).subscribe(result => {
        this.ownerEmailValidationResult = result;
        this.isValidatingOwnerEmail = false;
      });
    } else {
      // Input is name/principal - search for users
      console.log('👤 Owner input looks like name, searching users...');
      this.isValidatingOwnerEmail = false;
      this.isSearchingOwner = true;
      
      this.emailValidationService.searchUsers(input).subscribe(results => {
        this.ownerSearchResults = results;
        this.showOwnerDropdown = results.length > 0;
        this.isSearchingOwner = false;
      });
    }
  }
  
  // Select user from owner dropdown (reused logic)
  selectOwner(user: UserSearchResult) {
    // Prefer userPrincipalName (corporate email) over email field
    const emailToUse = user.userPrincipalName || user.email;
    this.newOwnerEmail = emailToUse;
    this.showOwnerDropdown = false;
    this.ownerSearchResults = [];
    
    // Validate the selected email
    this.isValidatingOwnerEmail = true;
    this.emailValidationService.validateCorporateEmail(emailToUse).subscribe(result => {
      this.ownerEmailValidationResult = result;
      this.isValidatingOwnerEmail = false;
    });
  }
  
  // Close owner dropdown when clicking outside
  closeOwnerDropdown() {
    this.showOwnerDropdown = false;
  }

  // Check if we can transfer ownership (email is valid and exists in AD)
  canTransferOwnership(): boolean {
    const email = this.newOwnerEmail.trim();
    if (!email) return false;
    
    // If validation is disabled, always allow transfer
    if (environment.allow_non_validated_emails === true) {
      return true;
    }
    
    // Must have validation result and user must exist
    return this.ownerEmailValidationResult !== null && 
           this.ownerEmailValidationResult.exists === true &&
           this.ownerEmailValidationResult.isValid === true;
  }
  
  // Show transfer ownership input (step 2)
  showTransferOwnership() {
    this.showTransferOwnershipInput = true;
  }
  
  // Get display text for multiple links (reused from share dialog)
  getLinksDisplayText(): string {
    if (this.selectedItemsForOwnerChange.length === 0) return '';
    if (this.selectedItemsForOwnerChange.length === 1) {
      return this.selectedItemsForOwnerChange[0].shortUrlId;
    }
    if (this.selectedItemsForOwnerChange.length === 2) {
      return `${this.selectedItemsForOwnerChange[0].shortUrlId} and ${this.selectedItemsForOwnerChange[1].shortUrlId}`;
    }
    const remaining = this.selectedItemsForOwnerChange.length - 2;
    return `${this.selectedItemsForOwnerChange[0].shortUrlId}, ${this.selectedItemsForOwnerChange[1].shortUrlId}, and ${remaining} more`;
  }

  // Change owner/creator (supports bulk)
  changeOwner() {
    const newOwnerEmail = this.newOwnerEmail.trim();
    
    if (!newOwnerEmail) {
      this.showSimpleNotification('Please enter a valid email address', 'error');
      return;
    }

    // Check if email is validated and exists in Azure AD
    if (!this.canTransferOwnership()) {
      if (this.ownerEmailValidationResult && !this.ownerEmailValidationResult.exists) {
        this.showSimpleNotification('User not found in organization. Please enter a valid corporate email address.', 'error');
      } else if (this.ownerEmailValidationResult && !this.ownerEmailValidationResult.isValid) {
        this.showSimpleNotification('Please enter a valid email address.', 'error');
      } else {
        this.showSimpleNotification('Please wait for email validation to complete.', 'info');
      }
      return;
    }

    if (this.selectedItemsForOwnerChange.length > 0) {
      // Process each selected item
      let changedCount = 0;
      const oldOwners = new Set<string>();
      
      this.selectedItemsForOwnerChange.forEach((item: any) => {
        const oldOwnerEmail = item.creator;
        
        // Skip if owner is not actually changing
        if (oldOwnerEmail === newOwnerEmail) {
          return;
        }
        
        oldOwners.add(oldOwnerEmail);
        changedCount++;
        
        // Update creator field
        item.creator = newOwnerEmail;
        item.modifiedAt = new Date().toISOString();
        
        // Note: multiOwnership not used anymore, icon driven by selectedPeople array
        
        // Initialize selectedPeople array if it doesn't exist
        if (!item.selectedPeople) {
          item.selectedPeople = [];
        }
        
        // Add old owner to shared people list if not already there
        const oldOwnerExists = item.selectedPeople.some(
          (person: any) => person.email === oldOwnerEmail
        );
        
        if (!oldOwnerExists && oldOwnerEmail) {
          item.selectedPeople.push({
            email: oldOwnerEmail
          });
        }
        
        // Add new owner to shared people list if not already there
        const newOwnerExists = item.selectedPeople.some(
          (person: any) => person.email === newOwnerEmail
        );
        
        if (!newOwnerExists) {
          item.selectedPeople.push({
            email: newOwnerEmail
          });
        }
        
        // Deselect item after processing
        item.selected = false;
      });
      
      if (changedCount === 0) {
        this.showSimpleNotification('The new owner email is the same as the current owner for all selected links', 'info', uxControls.notificationDuration);
        return;
      }
      
      // Persist ownership changes to backend
      console.log('Saving ownership changes to backend for ' + changedCount + ' link(s)');
      
      // Prepare update payload for backend (using UpdateShortLinkInput format)
      const updates = this.selectedItemsForOwnerChange
        .filter(item => item.creator === newOwnerEmail) // Only items that were actually changed
        .map(item => ({
          _id: item._id,
          creator: item.creator,
          multiOwnership: null, // Not used anymore, icon driven by selectedPeople array
          selectedPeople: item.selectedPeople || []
        }));
      
      // Call backend PUT endpoint to persist ownership changes
      this.configService.put(API_ENDPOINT_CREATE, updates, '').subscribe(
        (resp) => {
          console.log('✅ Ownership changes saved successfully:', resp);
          
          const linkText = changedCount === 1 ? 'link' : 'links';
          const oldOwnerList = Array.from(oldOwners).join(', ');
          this.showSimpleNotification(
            `Ownership transferred for ${changedCount} ${linkText} to ${newOwnerEmail}. Previous owner(s) (${oldOwnerList}) are now collaborators with edit permissions.`,
            'success',
            uxControls.notificationDuration
          );
          
          // Update selected count and close modal
          this.updateSelectedCount();
          this.closeChangeOwnerModal();
          
          // Refresh data to get latest from backend
          this.getAdminArea();
        },
        (error) => {
          console.error('❌ Failed to save ownership changes:', error);
          this.showSimpleNotification('Failed to change ownership. Please try again.', 'error', uxControls.notificationDuration);
          
          // Revert local changes on error by refreshing from backend
          this.getAdminArea();
        }
      );
      console.log('Old owners:', Array.from(oldOwners));
    }
  }
}

